export { default } from './ComplectationStorage';
